import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { HomeService, Foo } from './home.service';
import { AppService } from '../app.service';
import { Environment } from '../../environments/environment';
import { NotificationService } from '../NotificationComponent/notification.service';
import { Globals } from '../globals';
import { AuthenticationService } from '../auth';
import translateJson from "../../translate.json";

@Component({
  selector: 'home-comp',
  providers: [HomeService, AppService, NotificationService, AuthenticationService],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent {
    router: Router;
    env: any;
    
    // Get translation/text from customerJson
    private i18 = translateJson.i18;

    constructor(private http: HttpClient, 
      private appService: AppService,
      private globals: Globals, 
      private homeService: HomeService, 
      private notificationService: NotificationService,
      private authService: AuthenticationService) {
        this.authService.isAuthenticated();
        document.body.style.overflow = "auto";
        this.env = Environment;
        this.updateMessages();     
    }    

    /**
     * Set route on click
     * @param routerLink route name
     * @param active if the route is active
     */
    setRoute(routerLink, active) {
      if (active) {
        this.appService.setRoute(routerLink);
      }      
    }

    /**
     * When leaving the component
     */
    ngOnDestroy(){
      document.body.style.overflow = "hidden";
  }
  
  updateMessages() {
    if(this.globals.userrole === 'ROLE_USERS' || this.globals.userrole === 'ROLE_ADMINS') {
      this.notificationService.getAllMessages().subscribe(
        data => this.setMessageCount(data),
        error => console.log(error)
      )
    }
  }

  setMessageCount(messages) {
    let actualMessage = messages.messages;
    let numberOfMessages: number = 0;

    if(actualMessage.length > 0) {
      for(let i=0; i < actualMessage.length; i++) {
        if(!actualMessage[i].messageRead && !actualMessage[i].messageDeleted) {
          numberOfMessages = numberOfMessages + 1;
        }
      }
      this.globals.messages = numberOfMessages;
    }
  }
}
